import React from 'react';
import { useTranslation } from 'react-i18next';
import InviteIndividualIcon from 'assets/svgs/inviteIndividual.svg';
import PropTypes from 'prop-types';
import InitialStatus from './InitialStatus';

const InviteIndividual = ({
  invitedStaff,
  id,
  currentUserId,
  setInvitedStaff,
  setAlert,
  staffActions,
  tcEvent,
  name,
}) => {
  const { t } = useTranslation();
  return (
    <div className="invite-individual-container">
      <div className="invite-individual-header">
        <InviteIndividualIcon />
        {t('staffAndRoomsManagement.staffPool.inviteStaffLabel')}
      </div>
      <div className="invite-individual-search">
        <InitialStatus
          invitedStaff={invitedStaff}
          setInvitedStaff={setInvitedStaff}
          id={id}
          name={name}
          currentUserId={currentUserId}
          setAlert={setAlert}
          staffActions={staffActions}
          tcEvent={tcEvent}
        />
      </div>
    </div>
  );
};

export default InviteIndividual;

InviteIndividual.propTypes = {
  id: PropTypes.number.isRequired,
  currentUserId: PropTypes.number.isRequired,
  invitedStaff: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      status: PropTypes.string,
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
  setInvitedStaff: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
};
